import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { FormattedDate } from './FormattedDate';
import { AttributionTag } from './AttributionTag';
const useStyles = createUseStyles({
    card: {
        fontFamily: 'sans-serif',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '4px',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '1em',
        boxShadow: '0 1px 5px rgba(0,0,0,0.2)',
        transition: 'all .25s ease-in-out',
        maxWidth: 632,
    },
    content: {
        fontSize: 'larger',
    },
    date: {
        color: 'rgb(0, 0, 0, 60%)',
    },
    attribution: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        '& a': {
            color: 'black',
            textDecoration: 'none',
        },
        '& a:hover': {
            textDecoration: 'underline',
        },
        '& img': {
            marginRight: 5,
            width: 47,
            borderRadius: 5,
        },
    },
});
export const NoteCard = ({ content, published, attributedTo, }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.card },
        React.createElement("div", { className: classes.attribution },
            React.createElement(AttributionTag, { to: attributedTo })),
        React.createElement("p", { className: classes.content }, content),
        React.createElement(FormattedDate, { className: classes.date, value: published })));
};
//# sourceMappingURL=NoteCard.js.map